import PropTypes from "prop-types";
// @mui
import { alpha } from "@mui/material/styles";
import { Box, Card, Typography, Stack } from "@mui/material";
// utils
import { fNumber, fPercent } from "../../../../utils/formatNumber";
// components
import Iconify from "../../../../components/iconify";
import Chart from "../../../../components/chart";

// ----------------------------------------------------------------------

AppWidgetSummary.propTypes = {
  sx: PropTypes.object,
  title: PropTypes.string,
  total: PropTypes.number,
  percent: PropTypes.number,
  date: PropTypes.string,
};

export default function AppWidgetSummary({
  title,
  total,
  date,
  prefix,
  sx,
  ...other
}) {
  return (
    <Card
      sx={{ display: "flex", alignItems: "center", p: 3, ...sx }}
      {...other}
    >
      <Box sx={{ flexGrow: 1 }}>
        <Typography variant="subtitle2">{title}</Typography>

        {date ? (
  <Typography variant="h3">
    {date}
  </Typography>
) : (
  <Typography variant="h3">
    {prefix}
    {fNumber(total, 0) ? fNumber(total, 0) : 0}
  </Typography>
)}

        {/* <Typography variant="h3">
          {prefix}
          {fNumber(total) ? fNumber(total) : 0}
        </Typography>

        {date && (
          <Typography variant="body2" color="text.secondary">
            {date}
          </Typography>
        )} */}
      </Box>
    </Card>
  );
}

// ----------------------------------------------------------------------

TrendingInfo.propTypes = {
  percent: PropTypes.number,
};

function TrendingInfo({ percent }) {
  return (
    <Stack direction="row" alignItems="center" sx={{ mt: 2, mb: 1 }}>
      <Iconify
        icon={percent < 0 ? "eva:trending-down-fill" : "eva:trending-up-fill"}
        sx={{
          mr: 1,
          p: 0.5,
          width: 24,
          height: 24,
          borderRadius: "50%",
          color: "success.main",
          bgcolor: (theme) => alpha(theme.palette.success.main, 0.16),
          ...(percent < 0 && {
            color: "error.main",
            bgcolor: (theme) => alpha(theme.palette.error.main, 0.16),
          }),
        }}
      />

      <Typography component="div" variant="subtitle2">
        {percent > 0 && "+"}

        {fPercent(percent)}
      </Typography>
    </Stack>
  );
}
